import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { CurrentUserProvider } from 'context/currentUserContext';
import { GlobalSettingProvider } from '@hrtps/ui';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
        <CurrentUserProvider>
            <GlobalSettingProvider siderMenuTheme="dark">
                <App />
            </GlobalSettingProvider>
        </CurrentUserProvider>
    </ConfigProvider>,
    document.getElementById('root')
);

serviceWorker.unregister();
